export const desktopBreakpoint = 928;
export const tabletBreakpoint = 496;

// iphone X as default width (could be smaller or bigger, but these +- 20 till 40px won't make a difference)
export const maxWidth = 375;
export const maxWidthAnswer = 155.5;

// won't be exceeded in the build campaign
export const maxWidthTablet = 448;
export const maxWidthTabletAnswer = 216;
export const maxWidthDesktop = 608;
export const maxWidthDesktopAnswer = 216;
export const maxWidthUnframed = 960;
export const maxImageRatio = 200;

// Images
export const sizeRatioDetails = {
    small: {
        width: 16,
        height: 9,
    },
    medium: {
        width: 4,
        height: 3,
    },
    large: {
        width: 6,
        height: 5,
    },
    xLarge: {
        width: 1,
        height: 1,
    },
    answer: {
        width: 4,
        height: 3,
    },
    listItem: {
        width: 1,
        height: 1,
    },
};

export const imgixAr = {
    // 16 / 9
    small: sizeRatioDetails.small.width / sizeRatioDetails.small.height,
    // 4 / 3
    medium: sizeRatioDetails.medium.width / sizeRatioDetails.medium.height,
    // 6 / 5,
    large: sizeRatioDetails.large.width / sizeRatioDetails.large.height,
    // 1 / 1
    xLarge: sizeRatioDetails.xLarge.width / sizeRatioDetails.xLarge.height,
    // 4 / 3
    answer: sizeRatioDetails.answer.width / sizeRatioDetails.answer.height,
    // 1 / 1
    listItem: sizeRatioDetails.listItem.width / sizeRatioDetails.listItem.height,
};

export const sizeRatioMap = {
    // 16 / 9
    small: (sizeRatioDetails.small.height * 100) / sizeRatioDetails.small.width,
    // 4 / 3
    medium: (sizeRatioDetails.medium.height * 100) / sizeRatioDetails.medium.width,
    // 6 / 5,
    large: (sizeRatioDetails.large.height * 100) / sizeRatioDetails.large.width,
    // 1 / 1
    xLarge: (sizeRatioDetails.xLarge.height * 100) / sizeRatioDetails.xLarge.width,
    // 4 / 3
    answer: (sizeRatioDetails.answer.height * 100) / sizeRatioDetails.answer.width,
    // 1 / 1
    listItem: (sizeRatioDetails.listItem.height * 100) / sizeRatioDetails.listItem.width,
};

// Calendly
export const CALENDLY_URL_REGEX = /(https?:\/\/calendly\.com)\/([a-z0-9-_@+]*)\/([a-z0-9-_@+]+)/g;
export const CALENDLY_EVENT_SCHEDULED = 'calendly.event_scheduled';
